import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../../../common/modal/Modal';
import DeleteItineraryFoodForm from './DeleteItineraryFoodForm';
import { deleteItineraryFood } from '../../../../../actions/itinerary/ItineraryAdditionalFood';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { ITINERARY_ADDITIONAL_FOOD_ENDPOINT } from '../../../../../config/endpoints';
import { DELETE } from '../../../../../config/permissions';

const DeleteItineraryFoodButton = ({
  dispatchDeleteItineraryFood,
  itineraryId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const closeModal = () => setShowModal(false);

  const onModalSubmit = async (formValues) => {
    const { supplierId } = formValues;

    const normalizedSupplierId = supplierId
      ? supplierId.value || supplierId
      : null;

    if (!normalizedSupplierId) return;

    const response = await dispatchDeleteItineraryFood(
      itineraryId,
      normalizedSupplierId,
    );

    if (response) {
      closeModal();
    }
  };

  const openModal = () => setShowModal(true);

  const buildModalBody = () => {
    const newModalBody = (
      <DeleteItineraryFoodForm
        onCancel={closeModal}
        handleProcess={onModalSubmit}
      />
    );

    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal
        show={showModal}
        title="Eliminar Alimentación por Proveedor"
        body={modalBody}
        size="md"
      />

      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar Alimentación
      </Button>
    </>
  );
};

DeleteItineraryFoodButton.propTypes = {
  dispatchDeleteItineraryFood: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

DeleteItineraryFoodButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteItineraryFood: deleteItineraryFood,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(DeleteItineraryFoodButton);

export default withEndpointAuthorization({
  url: ITINERARY_ADDITIONAL_FOOD_ENDPOINT,
  permissionType: DELETE,
})(connectedComponent);
